import {defineMessages} from 'react-intl'

import saveQuery from '../api/saveQuery'

import fetchQueries from './fetchQueries'
import addNotification from './addNotification'

import getCurrentQuery from '../utils/getCurrentQuery'
import {toApi} from '../utils/apiMapper'

const messages = defineMessages({
  title: {
    id: "Can't save this query", 
    defaultMessage: "Can't save this query"
  },
  message: {
    id: "This query couldn't be saved, try again later", 
    defaultMessage: "This query couldn't be saved, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onSave = dispatch => (err, savedQuery) => {
  if(err){
    dispatch(addNotification(notification))
    return console.error("Failed to save the query")
  }
  dispatch({type: 'reset_new_query_name'})
  dispatch(fetchQueries())
}

export default (query) => (dispatch, getState) => {
  const query = getCurrentQuery()
  const state = getState()
  const name = state.newQueryName
  const {token, userName} = state.session
  const apiQuery = toApi(query, state) 

  saveQuery(name, apiQuery, userName, token, onSave(dispatch))

}



/** WEBPACK FOOTER **
 ** ./app/actions/saveNewQuery.js
 **/